exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-block {\r\n    width: auto;\r\n}\r\n\r\n.row-block {\r\n    width: 100% !important;\r\n    display: block !important;\r\n}\r\n", ""]);

// exports
